import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 0V12",
		stroke: "#FF3131",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 6L-1.78814e-07 6",
		stroke: "#FF3131",
		strokeLinejoin: "round"
	})]
});
export default SvgNewIcon;
